import * as React from 'react';
import { Spinner } from '@cian/ui-kit';
import { PictogramPlaceholderImages40 } from '@cian/ui-kit-design-tokens/pictograms';
import { clsx } from 'clsx';

import * as styles from './Slide.css';

export interface ISlideProps {
  src: string;
}

enum ELoadingStatus {
  Failure = 'failure',
  Loading = 'loading',
  Success = 'success',
}

export const Slide: React.VFC<ISlideProps> = ({ src }) => {
  const [status, setStatus] = React.useState(ELoadingStatus.Loading);

  const handleLoad = React.useCallback(() => setStatus(ELoadingStatus.Success), []);
  const handleError = React.useCallback(() => setStatus(ELoadingStatus.Failure), []);

  return (
    <div className={styles['image-layout']} data-testid="Slide">
      <img
        className={clsx(styles['image'], status === ELoadingStatus.Failure && styles['image__hidden'])}
        src={src}
        onLoad={handleLoad}
        onError={handleError}
        loading="lazy"
      />

      {status === ELoadingStatus.Failure && (
        <div className={styles['overlay']} data-testid="SlideEmpty">
          <PictogramPlaceholderImages40 color="icon-inverted-default" />
        </div>
      )}

      {status === ELoadingStatus.Loading && (
        <div className={styles['overlay']} data-testid="SlideSpinner">
          <Spinner color="icon-inverted-default" size={40} />
        </div>
      )}
    </div>
  );
};
